
//Représente la vue d’une vente
export class RetournerVueVenteResultat {
  // Titre
  public titre!: string;

  // Date de la facture
  public dateFacture!: Date;

  // Code du processus métier
  public processusMetier!: string;

  // Dénomination du tiers facturé
  public tiersFacture!: string;

  // Statut actuel de la pièce
  public statutActuel!: string;

  // Code couleur du statut actuel de la pièce
  public codeCouleurStatutActuel!: string;

  // Date du statut actuel
  public dateStatutActuel!: Date;

  // Montant TTC
  public montantTtc!: number;

  // Montant encaissé déclaré
  public montantEncaisseDeclare!: number;

  // Date d'échéance
  public dateEcheance!: Date | null;

  // Référence de la pièce
  public reference!: string;

  // Interlocuteur du tiers facturé
  public interlocuteurTiersFacture!: string;

  // Email de l'interlocuteur du tiers facturé
  public emailInterlocuteurTiersFacture!: string;

  // Identifiant d'adressage du tiers facturé
  public identifiantAdressageTiersFacture!: string;

  // Identifiant complémentaire du tiers facturé
  public identifiantComplementaireTiersFacture!: string;

  // Montant HT
  public montantHt!: number;

  // Montant TVA
  public montantTva!: number;

  // Montant Accompte
  public montantAcompte!: number;

  // Montant net à payer
  public montantNetAPayer!: number;

  // Nombre de jours avant échéance
  public nombreJoursAvantEcheance!: number | null;

  // Référence de l'acheteur
  public acheteurReference!: string;

  // Référence du bon de commande de l'acheteur
  public acheteurBonCommandeReference!: string;

  // Référence du contrat
  public contratReference!: string;

  // Référence du projet
  public projetReference!: string;

  // Référence de l'appel d'offre
  public appelOffreReference!: string;

  // Indique si le statut actuel de la pièce est éligible à une modification manuelle
  public estStatutModifiable!: boolean;
}
